export const VERIFICATION_ID_TYPE_NATIONAL = "national_id";
export const VERIFICATION_ID_TYPE_PASSPORT = "passport";

export const VERIFICATION_STATUS_NONE = "none";
export const VERIFICATION_STATUS_PENDING = "pending";
export const VERIFICATION_STATUS_APPROVED = "approved";
export const VERIFICATION_STATUS_REJECTED = "rejected";

export function getDefaultVerificationState() {
  return {
    status: VERIFICATION_STATUS_NONE,
    id_type: VERIFICATION_ID_TYPE_NATIONAL,
    has_id_document: false,
    has_face_video: false,
    has_address_document: false,
    rejection_reason: "",
  };
}
